import React, { createContext, useState, useEffect } from "react";

export const AnnotationContext = createContext();

export const AnnotationProvider = ({ children }) => {
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const resetSelectedAnnotation = () => {
    setSelectedAnnotation(null);
  };

  return (
    <AnnotationContext.Provider
      value={{
        selectedAnnotation,
        setSelectedAnnotation,
        activeTab,
        setActiveTab,
        resetSelectedAnnotation,
      }}
    >
      {children}
    </AnnotationContext.Provider>
  );
};
